<template>
  <div class="header-wrap" @mouseleave="headerLeave">
    <div class="header" id="header" :class="{ 'header--product': isProduct }">
      <div class="header__menu">
        <div class="header__logo" @click="logoScrollTop" @mouseover="otherHover">
          <img class="logo logo__white" src="../assets/img/ic_logo_white.png" alt="logo">
          <img class="logo logo__black" src="../assets/img/ic_logo_black.png" alt="logo">
        </div>
        <div class="nav">
          <b-nav class="nav__list no-drag">
            <b-nav-item class="nav__item" to="/technology" @click="scrollTop"
                        @mouseover="otherHover"
                        exact-active-class="active">{{$t('menu.technology')}}</b-nav-item>
            <b-nav-item class="nav__item" :class="{ 'product--active': isProduct }"
                        @mouseover="productHover" to="/product/wearable"
                        exact-active-class="active">{{$t('menu.products')}}</b-nav-item>
            <b-nav-item class="nav__item" to="/about" @click="scrollTop"
                        @mouseover="otherHover"
                        exact-active-class="active">{{$t('menu.about')}}</b-nav-item>
          </b-nav>
        </div>

        <!-- ** Change Language Start ** -->
        <div v-if="$i18n.locale() === 'ko'" class="header__lang no-drag"
             @mouseover="otherHover" @click="changeLang('en')">{{$t('menu.language.en')}}</div>
        <div v-else class="header__lang no-drag"
             @mouseover="otherHover" @click="changeLang('ko')">{{$t('menu.language.kr')}}</div>
        <!-- ** Change Language End ** -->

        <div class="header__sidebar">
          <button class="sidebar__btn" v-b-toggle.sidebar-backdrop>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <!-- product menu in header Start -->
    <div class="header__product" id="headerProduct"
         :class="{ 'header__product--other': !isProduct, 'hidden': !isProduct && !isProductHover,
         'd-none': !isShrinkHeader }">
      <div class="product__nav">
        <b-nav class="product__nav__list no-drag">
          <b-nav-item class="product__nav__item" to="/product/wearable"
                      exact-active-class="active">{{$t('menu.wearable')}}</b-nav-item>
          <b-nav-item class="product__nav__item" to="/product/baby"
                      exact-active-class="active">{{$t('menu.baby')}}</b-nav-item>
          <b-nav-item class="product__nav__item" to="/product/bed"
                      exact-active-class="active">{{$t('menu.bed')}}</b-nav-item>
          <b-nav-item class="product__nav__item" to="/product/golf"
                      exact-active-class="active">{{$t('menu.golf')}}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <!-- product menu in header End -->

    <!-- product menu in top bar Start -->
    <div class="header__product--top-bar" id="topBarProduct"
         :class="{ 'hidden': !isProductHover, 'd-none': isShrinkHeader }">
      <div class="product__nav">
        <b-nav class="product__nav__list no-drag">
          <b-nav-item class="product__nav__item" to="/product/wearable"
                      exact-active-class="active">{{$t('menu.wearable')}}</b-nav-item>
          <b-nav-item class="product__nav__item" to="/product/baby" @click="scrollTop"
                      exact-active-class="active">{{$t('menu.baby')}}</b-nav-item>
          <b-nav-item class="product__nav__item" to="/product/bed" @click="scrollTop"
                      exact-active-class="active">{{$t('menu.bed')}}</b-nav-item>
          <b-nav-item class="product__nav__item" to="/product/golf" @click="scrollTop"
                      exact-active-class="active">{{$t('menu.golf')}}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <!-- product menu in top bar End -->
  </div>
</template>

<script>
import { checkProductPathMixin } from './mixins/checkProductPath';

const shrinkHeader = 1;

export default {
  name: 'Header',
  data() {
    return {
      isProductHover: false,
      isShrinkHeader: true,
    };
  },
  mixins: [checkProductPathMixin],
  async created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scroll = this.getCurrentScroll();
      const header = document.getElementById('header');
      if (scroll >= shrinkHeader) {
        header.classList.add('header--shrink');
        this.isShrinkHeader = false;
      } else {
        header.classList.remove('header--shrink');
        this.isShrinkHeader = true;
      }
    },
    getCurrentScroll() {
      return window.pageYOffset || document.documentElement.scrollTop;
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    logoScrollTop() {
      this.$router.push('/').catch(() => {});
      this.scrollTop();
    },
    productHover() {
      this.isProductHover = true;
    },

    // 마우스가 헤더 영역을 벗어난 경우 product 하위 메뉴 숨기기
    headerLeave() {
      this.isProductHover = false; // false
    },
    // 마우스가 다른 메뉴 영역으로 들어온 경우 product 하위 메뉴 숨기기
    otherHover() {
      this.isProductHover = false; // false
    },

    // 언어 설정 변경
    changeLang(langCode) {
      sessionStorage.setItem('langCode', langCode);
      // eslint-disable-next-line no-restricted-globals
      history.go(0);
      this.$i18n.set(langCode);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/constant';
  @import '../assets/scss/mixins';

  .hidden {
    opacity: 0!important;
    height: 0!important;
    overflow: hidden!important;
  }

  /* ------------------
  :: Header Area CSS
  ------------------ */
  .header-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;

    @include flexbox;
    @include flex-direction(column);
    @include align-items(center);
  }
  .header {
    display: inline-flex;
    width: 100%;
    background: transparent;
    color: $color-white;
    overflow: hidden;
    -webkit-transition: height 0.4s, background 0.4s;
    -moz-transition: height 0.4s, background 0.4s;
    transition: height 0.4s, background 0.4s;
    text-align:center;

    height: 90px;
    padding-left: 30px;
    padding-right: 30px;

    font-size: 16px;

    // product nav active Start
    &--product {
      color: $color-light-gray;
      .header__lang {
        border: solid 1px $color-light-gray;
      }
      .header__logo > .logo {
        &.logo__white { display: none; }
        &.logo__black { display: block; }
      }
    }
    .product--active {
      color: $color-header-gray!important;
    }
    // product nav active End

    &__menu {
      @include flexbox;
      @include justify-content(space-between);
      @include align-items(center);

      height: 100%;
      width: 100%;
      max-width: 1576px;
    }

    &__logo {
      & > .logo {
        width: 120px;
        cursor: pointer;
        &.logo__black {
          display: none;
        }
      }
    }

    &__lang {
      display: none;
      line-height: 27px;
      min-width: 80px;
      height: 29px;
      border: solid 1px $color-white;
      cursor: pointer;
      margin-left: 20px;
    }

    &--shrink {
      height: 60px;
      background: rgba(255, 255, 255, 0.9);
      color: $color-light-gray;
      -webkit-box-shadow: 0 2px 80px rgba(0, 0, 0, 0.20);
      box-shadow: 0 2px 80px rgba(0, 0, 0, 0.20);

      & .header__lang {
        border: solid 1px $color-light-gray;
      }

      & .header__logo {
        & .logo__black {
          display: block;
        }
        & .logo__white {
          display: none;
        }
      }
    }

    .nav {
      display: none;
    }
    .nav-link {
      padding: 0;
      color: inherit;
      &.active {
        color: $color-header-gray;
      }
    }
  }

  .header__product {
    display: none;
    width: 100%;
    padding-left: 30px;
    padding-right: 30px;
    color: $color-light-gray;
    font-size: 16px;
    letter-spacing: 1.92px;
    @include justify-content(center);

    opacity: 1;
    -webkit-transition: opacity 0.5s, height 0.5s;
    -moz-transition: opacity 0.5s, height 0.5s;
    transition: opacity 0.5s, height 0.5s;

    &--other {
      color: $color-white;
    }

    .product__nav {
      @include flexbox;
      @include flex-direction(column);
      @include align-items(flex-end);
      width: 100%;
      max-width: 1576px;

      &__list {
        width: 1100px;
        border-top: solid 1px $color-light-gray;
        padding-top: 25px!important;
      }

      &__item {
        @include flex(1);
        &:nth-of-type(1) { text-align: left; }
        &:nth-of-type(2) { text-align: center; }
        &:nth-of-type(3) { text-align: center; }
        &:nth-of-type(4) { text-align: right; }

        &:hover {
          color: $color-header-gray;
        }
        & > a {
          padding: 6px;
        }
      }
    }
    .nav-link {
      padding: 0;
      color: inherit;
      &.active {
        color: $color-header-gray;
      }
    }
  }

  .header__product--top-bar {
    width: 100%;
    height: 50px;
    padding-left: 30px;
    padding-right: 30px;
    color: $color-white;
    font-size: 16px;
    letter-spacing: 1.92px;
    @include flexbox;
    @include justify-content(center);

    opacity: 1;
    -webkit-transition: opacity 0.5s, height 0.5s;
    -moz-transition: opacity 0.5s, height 0.5s;
    transition: opacity 0.5s, height 0.5s;

    background-color: rgba(197, 197, 197, 0.9);

    .product__nav {
      @include flexbox;
      @include flex-direction(column);
      @include align-items(flex-end);
      @include justify-content(center);
      width: 100%;
      max-width: 1576px;

      &__list {
        width: 1100px;
      }

      &__item {
        @include flex(1);
        &:nth-of-type(1) { text-align: left; }
        &:nth-of-type(2) { text-align: center; }
        &:nth-of-type(3) { text-align: center; }
        &:nth-of-type(4) { text-align: right; }

        &:hover {
          color: $color-light-gray;
        }
        & > a {
          padding: 6px;
        }
      }
    }
    .nav-link {
      padding: 0;
      color: inherit;
      &.active {
        color: $color-light-gray;
      }
    }
  }

  @media (min-width: 768px) {
    .header {
      @include justify-content(center);
      height: 120px;

      &__logo > .logo {
        width: 211px;
      }
      &__lang {
        display: block;
        &:hover {
          border: solid 1px $color-header-gray;
          color: $color-header-gray;
        }
      }
      &--shrink {
        height: 80px;
      }

      .nav {
        @include flexbox;
        @include flex(1);
        @include justify-content(flex-end);

        &__list {
          @include flexbox;
        }
        &__item {
          letter-spacing: 1.92px;
          margin-left: 20px;
          cursor: pointer;
          white-space: nowrap;

          &:hover {
            color: $color-header-gray;
          }
          & > a {
            padding: 6px;
          }
        }
      }
    }
    .header__product {
      @include flexbox;
    }
  }
  @media (min-width: 992px) {
    .header {
      &__lang {
        margin-left: 59px;
      }
      .nav {
        &__item {
          margin-left: 61px;
        }
      }
    }
  }

  /* ------------------
  :: Sidebar Area CSS
  ------------------ */
  .sidebar {
    &__btn {
      display: block;
      color: white;
      & > svg {
        width: 30px;
        height: 30px;
      }
    }
  }
  // product nav active Start
  .header--product {
    .sidebar__btn {
      color: $color-light-gray;
    }
  }
  .header {
    &--shrink {
      .sidebar {
        &__btn {
          color: $color-light-gray;
        }
      }
    }
  }
  @media (min-width: 768px) {
    .sidebar {
      &__btn {
        display: none;
      }
    }
  }

</style>
